export const birthdayNotificationpayload = (receiver, mailSubject, mailBody, mailSignature, fcmBody, fcmTitle, smsMessage, creatorIdentifier, organizationIdentifier, appId, clickAction) => {
    return {
        creatorIdentifier,
        organizationIdentifier,
        templates: {
            email: {
                subject: mailSubject,
                body: `${mailBody} \n \n${mailSignature}`
            },
            sms: {
                message: smsMessage
            },
            fcm: {
                appId: appId,
                payLoad: {
                    badge: 1,
                    sound: "sound",
                    clickAction: clickAction,
                    body: "{}",
                    notificationBody: fcmBody,
                    notification: false
                },
                title: fcmTitle
            }
        },
        data: {
            selectedUsers: [
                {
                    username: receiver?.email,
                    email: receiver?.email,
                    number: receiver?.telephone
                }
            ],
            selectedGroup: []
        }
    }
}

export const patientUpdatePayload = (receivers, mailSubject, mailBody, fcmBody, fcmTitle, smsMessage, creatorIdentifier, organizationIdentifier, appId, clickAction) => {
    return {
        creatorIdentifier,
        organizationIdentifier,
        templates: {
            email: {
                subject: mailSubject,
                body: `${mailBody}`
            },
            sms: {
                message: smsMessage
            },
            fcm: {
                appId: appId,
                payLoad: {
                    badge: 1,
                    sound: "sound",
                    clickAction: clickAction,
                    body: "{}",
                    notificationBody: fcmBody,
                    notification: false
                },
                title: fcmTitle
            }
        },
        data: {
            selectedUsers: receivers,
            selectedGroup: []
        }
    }
}
